<template lang="pug">
  main
    h1 Teach from an Existing Course
    aside(class="sidebar mission")
      h2 Courses Currently Available
      ul
        li
          a(href="https://circuits1.hvullc.com/") <strong>Circuits 1</strong>: Introduction to Electrical Circuits
          span &nbsp; taught by Tim Hanshaw (currently this course is offered at no charge)

    div(class="course-container")
      section(class="main-container just-text")
        div
          h2 The Group Leader Role
          p <strong><em>Supplement your STEM class with a course from HVU! </em></strong>
          p The group leader role is comparable to that of an instructor or a mentor. Group leaders invite or enroll students in their group. The group leader then <strong>has access to detailed metrics relative to the progress of the students</strong> in their group. The data available includes:

          ul
            li The <strong>types of activities (passive or active)</strong> the student is engaging in 
            li The <strong>level of difficulty of the practice problems</strong> the student is solving 
            li The <strong>level to which the student is engaging with the active materials</strong> by providing data relative to problems “attempted” and problems “completed”. Comparing these numbers allows a group leader to assess whether the student is successfully solving problems independently or simply using the assistance materials to walk through problems  
            li The students’ <strong>quiz scores</strong>

          p The goal of providing these metrics is to allow group leaders to <strong>readily assess student progress</strong> and <strong>suggest more productive activities</strong> for struggling students. 
          p Group leaders can <strong>customize the “Instructor” information</strong> displayed to their students, and also have some ability to <strong>customize the practice and quiz problems</strong> seen by the students in their group. This can be done by removing or adding existing problems from the problem list seen by their group, or by creating new problems. New problems created by group leaders must be approved by an administrator. 
          p <strong><em>Contact us today to request Group Leader access and assistance in setting up an HVU course for your students. </em></strong>
          p
            a(href="mailto:feedback@hvullc.com") SIGN ME UP AS A GROUP LEADER
            br
            em (send email request to "feedback@hvullc.com")
</template>

<script>
export default {
  name: "ExistingCourse"
};
</script>
